const mediumProjects = [
    {
        id: 4,
        title: "Modularize the engine module in Network Stack Tester (NeST)",
        hours: 175,
        brief: "Network Stack Tester (NeST) has four main modules: topology module, experiment module, engine module and routing module. The engine module is used by all other modules since it is the interface to the Linux kernel. However, the engine module in NeST has grown larger and consists of 20 files. This is expected to grow more in future. The main goal of this project is to: (i) modularize the engine module by splitting the existing files into subdirectories while ensuring that the logical grouping of the files is not affected, and (ii) test the functionality of the engine module to confirm that modularizing it did not affect the overall functionality of the tool.",
        mentor: "Shanthanu S. Rai",
        requiredExperience: "Python",
        bonusExperience: "Knowledge of NeST is a plus",
        difficulty: "Low to Moderate",
        reading: [
            { title: "NeST website", link: "https://nest.l4.nitk.ac.in/" },
            {
                title: "NeST paper",
                link: "https://dl.acm.org/doi/abs/10.1145/3404868.3406670",
            },
            {
                title: "Modules in NeST",
                link: "https://nest.l4.nitk.ac.in/docs/v0.4/developer/architecture.html",
            },
            {
                title: "GitLab issue for this work",
                link: "https://gitlab.com/nitk-nest/nest/-/issues/229",
            },
        ],
    },
    {
        id: 5,
        title: "Enabling the support of Message Queue Telemetry Transport (MQTT) in NeST",
        hours: 175,
        brief: "Message Queue Telemetry Transport (MQTT) is a popular application layer protocol for Internet of Things (IoT). It is a broker based application protocol, and is widely used in real IoT deployments. Several implementations of MQTT broker are openly available, such as mosquitto. The goal of this project is to build APIs in NeST so that the users can easily perform emulations with MQTT in NeST. This is an ongoing effort at NITK and some preliminary work has been done towards achieving this goal.",
        requiredExperience: "Python",
        bonusExperience: "Knowledge of MQTT and Network Namespaces is a plus",
        difficulty: "Easy to Moderate",
        reading: [
            { title: "NeST website", link: "https://nest.l4.nitk.ac.in/" },
            {
                title: "NeST paper",
                link: "https://dl.acm.org/doi/abs/10.1145/3404868.3406670",
            },
            {
                title: "MR open for this work",
                link: "https://gitlab.com/nitk-nest/nest/-/merge_requests/230",
            },
        ],
    },
    {
        id: 6,
        title: "Enable the support of Multiple SSIDs over a Single AP in NeST",
        hours: 175,
        brief: "It is common for organizations to have multiple SSIDs in their WiFi network for various purposes, including: (i) to provide different security mechanisms for employees and an open network with a captive portal for guests; (ii) to split bandwidth among different types of users and services; or (iii) to minimize the costs by reducing the number of physical access points.",
        requiredExperience: "Python",
        bonusExperience:
            "Fundamentals of WiFi and the internal working of NeST",
        difficulty: "Moderate",
        reading: [
            { title: "NeST website", link: "https://nest.l4.nitk.ac.in/" },
            {
                title: "NeST paper",
                link: "https://dl.acm.org/doi/abs/10.1145/3404868.3406670",
            },
            {
                title: "Support of this feature in Mininet-WiFi",
                link: "https://mininet-wifi.github.io/advanced/#multiplessids",
            },
        ],
    },
    {
        id: 7,
        title: "Enable the support of Network Address Translation in Access Points in NeST",
        hours: 175,
        brief: "Most of the WiFi access points have an in-built support of Network Address Translation (NAT) and Dynamic Host Configuration Protocol (DHCP). NAT mode is used to allow the AP to create a DHCP subnet with its own NAT for the SSID. The AP then assigns preset subnets on the LAN side (connecting to WiFi stations) depending on the IP address that is assigned to the management WAN interface (connecting to the distribution system). The main goal of this project is to enable the support of NAT mode in APs in NeST.",
        requiredExperience: "Python and fundamentals of NAT",
        bonusExperience:
            "Fundamentals of WiFi and the internal working of NeST",
        difficulty: "Moderate",
        reading: [
            { title: "NeST website", link: "https://nest.l4.nitk.ac.in/" },
            {
                title: "NeST paper",
                link: "https://dl.acm.org/doi/abs/10.1145/3404868.3406670",
            },
            {
                title: "Support of this feature in Mininet-WiFi",
                link: "https://mininet-wifi.github.io/advanced/#nat",
            },
        ],
    },
    {
        id: 8,
        title: "Enable the support for configuring transmission range of a node in NeST",
        hours: 175,
        brief: "The transmission of a signal in wireless networks is limited to a specific range, and is subject to interference and obstacles. Modeling transmission range in network simulators / emulators is crucial to understand the real characteristics of a wireless network. In this project, the goal is to enable the support for configuring a wireless transmission range of a node (it could be a WiFi station or a WiFi AP) in NeST.",
        requiredExperience: "Python",
        bonusExperience:
            "Fundamentals of WiFi and the internal working of NeST",
        difficulty: "Moderate",
        reading: [
            { title: "NeST website", link: "https://nest.l4.nitk.ac.in/" },
            {
                title: "NeST paper",
                link: "https://dl.acm.org/doi/abs/10.1145/3404868.3406670",
            },
            {
                title: "Support of this feature in Mininet-WiFi",
                link: "https://mininet-wifi.github.io/commands/#range",
            },
        ],
    },
    {
        id: 9,
        title: "Enable the support for setting the transmission power of a node in NeST",
        hours: 175,
        brief: "The transmission power of a node affects the overall lifetime of battery operated devices, such as phones, tablets and wearable gadgets. Modeling transmission power in network simulators / emulators is crucial to understand the energy requirements of participating devices and also defines the transmission range of that node. In this project, the goal is to enable the support for setting transmission power of a node (WiFi stations or a WiFi AP) in NeST.",
        requiredExperience: "Python",
        bonusExperience:
            "Fundamentals of WiFi and the internal working of NeST",
        difficulty: "Moderate",
        reading: [
            { title: "NeST website", link: "https://nest.l4.nitk.ac.in/" },
            {
                title: "NeST paper",
                link: "https://dl.acm.org/doi/abs/10.1145/3404868.3406670",
            },
            {
                title: "Support of this feature in Mininet-WiFi",
                link: "https://mininet-wifi.github.io/commands/#txpower",
            },
        ],
    },
    {
        id: 10,
        title: "Enable the support for configuring a channel in a node in NeST",
        hours: 175,
        brief: "The 802.11 standard (WiFi) provides several distinct radio frequency bands for use: 900 MHz, 2.4 GHz, 3.6 GHz, 4.9 GHz, 5 GHz, 5.9 GHz, 6 GHz and 60 GHz. Each range is divided into a multitude of channels. Some of these channels are called non-overlapping channels because they do not interfere with each other. Hence, during real WiFi deployments, care is taken to ensure that two adjacent APs use non-overlapping channels to minimize the loss of throughput due to interference. Currently, NeST users cannot configure a channel while performing WiFi emulations. In this project, the goal is to enable the support for configuring a channel in a node (WiFi stations or a WiFi AP) in NeST.",
        requiredExperience: "Python",
        bonusExperience:
            "Fundamentals of WiFi and the internal working of NeST",
        difficulty: "Moderate",
        reading: [
            { title: "NeST website", link: "https://nest.l4.nitk.ac.in/" },
            {
                title: "NeST paper",
                link: "https://dl.acm.org/doi/abs/10.1145/3404868.3406670",
            },
            {
                title: "Support of this feature in Mininet-WiFi",
                link: "https://mininet-wifi.github.io/commands/#channel",
            },
        ],
    },
    {
        id: 11,
        title: "Enable the support for configuring node positions in NeST",
        hours: 175,
        brief: "Currently, NeST does not support providing positions (X, Y and Z coordinates) to nodes. Enabling this feature can help in several ways; for example, it will help to accurately set the transmission range/power and also help to make nodes move from one position to another (to emulate mobility of nodes). The goal of this project is to build APIs in NeST that allow the users to configure the node positions. The coordinates for every node may be entered by the user manually or it can be generated randomly by NeST internally.",
        requiredExperience: "Python",
        bonusExperience:
            "Fundamentals of WiFi and the internal working of NeST",
        difficulty: "Moderate",
        reading: [
            { title: "NeST website", link: "https://nest.l4.nitk.ac.in/" },
            {
                title: "NeST paper",
                link: "https://dl.acm.org/doi/abs/10.1145/3404868.3406670",
            },
            {
                title: "Support of this feature in Mininet-WiFi",
                link: "https://mininet-wifi.github.io/commands/#position",
            },
        ],
    },
];

export default mediumProjects;
